import { sortBy } from 'lodash';
import i18next from 'i18next';

import { CONSUMPTION_FREQUENCY } from '@admin/commons/constants/nonSalesConsumption';
import utilsXLS from '@commons/utils/makeXLS';

const createMainSheet = (ingredientConfig, currency) => {
  const columns = [
    {
      propertyKey: 'ingredientName',
      name: i18next.t('GENERAL.INGREDIENT_NAME'),
    },
    {
      propertyKey: 'category',
      name: i18next.t('GENERAL.CATEGORY'),
    },
    {
      propertyKey: 'bufferStock',
      name: i18next.t('GENERAL.BUFFER_STOCK'),
    },
    {
      propertyKey: 'consumptionFrequency',
      name: i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_COLUMN_TITLE'),
      transform: (consumptionFrequency) => {
        if (!consumptionFrequency) {
          return '';
        }

        const isDailyConsumption = consumptionFrequency === CONSUMPTION_FREQUENCY.DAILY;

        return isDailyConsumption
          ? i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_DAILY')
          : i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_PER_1000_CURRENCY', {
              currency,
            });
      },
    },
    {
      propertyKey: 'consumptionQuantity',
      name: i18next.t('ADMIN.STORES.CONSUMPTION_QUANTITY_COLUMN_TITLE'),
    },
  ];

  const sortedIngredientConfig = sortBy(ingredientConfig, 'ingredientName');

  return utilsXLS.generateDefaultSheet(
    i18next.t('ADMIN.SUB_FEATURES.ASSOCIATED_INGREDIENTS'),
    columns,
    sortedIngredientConfig,
  );
};

export const exportIngredientConfigXLS = (ingredientConfig, currency) => {
  const filename = i18next.t('ADMIN.STORES.EXPORT_ASSOCIATED_INGREDIENTS_LIST_FILENAME');

  const mainSheet = createMainSheet(ingredientConfig, currency);

  utilsXLS.makeXLS(filename, [mainSheet]);
};
